import {
    GET_MAQUINA_DETALLES, ADD_NEW_MAQUINA, ADD_LICENCIA_MAQUINA, MODIFY_LICENCIA_MAQUINA, DELETE_LICENCIA_MAQUINA
} from '../constants/action_types';

const initialState = { maquinalicencias: [], isLoading: false };

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_MAQUINA_DETALLES:

            return {
                maquinalicencias: [],
                isLoading: true
            };

        case GET_MAQUINA_DETALLES + "_SUCCESS":

            return {
                maquinalicencias: action.payload.data.licencias,
                isLoading: false
            };

        case ADD_LICENCIA_MAQUINA:

            const newArr = [...state.maquinalicencias, action.payload]

            return {
                maquinalicencias: newArr,
                isLoading: false
            };

        case DELETE_LICENCIA_MAQUINA:

            return {
                maquinalicencias: state.maquinalicencias.filter(licencia => licencia.id !== action.payload.id),
                isLoading: false
            };

        case MODIFY_LICENCIA_MAQUINA:

            return {
                maquinalicencias: state.maquinalicencias.map((licencia) => {
                    if (licencia.id !== action.payload.id) return licencia;
                    else return action.payload;
                }),
                isLoading: false
            };


        case ADD_NEW_MAQUINA:
            return initialState;

        default:

            return state;
    }

}